import request from '@/utils/request'
// 嘉宾接口

export function getPersonInfo (query) {
    return request({
        url: 'worker/info',
        method: 'get',
        params: query
    })
}

export function getArrivalInfo (query) {
    return request({
        url: 'worker/arrival',
        method: 'get',
        params: query
    })
}

export function getLeaveInfo (query) {
    return request({
        url: 'worker/leave',
        method: 'get',
        params: query
    })
}

export function getAccommodationInfo (query) {
    return request({
        url: 'worker/accommodation',
        method: 'get',
        params: query
    })
}

export function submitInfo (data) {
    return request({
        url: 'notcheck/register/worker',
        method: 'post',
        data
    })
}

export function updateArrival (data) {
    return request({
        url: 'worker/arrival',
        method: 'put',
        data
    })
}

export function updateLeave (data) {
    return request({
        url: 'worker/leave',
        method: 'put',
        data
    })
}

export function updateAccommodate (data) {
    return request({
        url: 'worker/accommodation',
        method: 'put',
        data
    })
}
